<template>
    <AddressDetails
        namespace="Enrolment"
        :setCountry="setHomeCountry"
        :homeCountry="home_country"
        :homeHouseNumber="home_house_number"
        :homeHouseName="home_house_name"
        :homeStreet="home_street"
        :countries="countries"
        :predictions="predictions"
        :emulatePlaceChange="emulatePlaceChange"
        :callAutoComplete="callAutoComplete"
        :getIsoCodeFromName="getIsoCodeFromName"
    >
        <template slot="header">
            <h1 v-translate>Sign up to SmartCharts</h1>
            <EnrolmentProgress :currentStage="$options.name" />
        </template>
        <template slot="body-title">
            <h3
                class="text-center"
                v-translate
            >Enter your home address</h3>
            <br>
        </template>
        <template
            slot="footer"
            slot-scope="{ submitForm, isValid }"
        >
            <EnrolmentFooter
                :isValid="isValid"
                :submitHandler="submitForm"
                :processStage="processStage"
                :prev="prev"
            />
        </template>
    </AddressDetails>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapMutations, mapState } from 'vuex';

import EnrolmentFooter from './Footer';
import EnrolmentProgress from '@C/EnrolmentProgress';
import AddressDetails from '@C/Enrolment/AddressDetails';

import EnrolmentMixin from '@M/enrolment';
import autocomplete from '@M/autocomplete';

export default {
    name: 'HomeAddress',
    data() {
        return {
            autocompleteIdentifier: 'home',
        };
    },
    created() {
        this.getOrganisedCountries();
    },
    beforeDestroy() {
        this.bus.$off('form:submit');
    },
    mounted() {
        this.bus.$on('form:submit', this.formHandler);
    },
    methods: {
        ...mapActions(['getOrganisedCountries']),
        ...mapActions('Enrolment', ['resetHomeFields']),
        ...mapMutations('Enrolment', ['setHomeCountry']),
        formHandler(e) {
            this.processStage(e);
        },
        addressFieldChanged: function () {
            if (typeof this.user.billing_address != 'undefined') {
                this.user.billing_address.same_as_home = false;
            }
        },
    },
    computed: {
        ...mapState({
            home_country: state => state.Enrolment.user.home_country,
            home_house_number: state => state.Enrolment.user.home_house_number,
            home_house_name: state => state.Enrolment.user.home_house_name,
            home_street: state => state.Enrolment.user.home_street
        }),
        ...mapState(['countries', 'bus']),
    },
    components: {
        EnrolmentFooter,
        EnrolmentProgress,
        AddressDetails
    },
    mixins: [EnrolmentMixin, autocomplete('Enrolment', 'home')]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/HomeAddress.vue